import React from "react";
import { Container, Row } from "shards-react";
import { getUsers } from "../backend/user";
import PageTitle from "../components/common/PageTitle";
import UsersTables from "../components/layout/admin/UsersTable";
import BovinePrice from "../components/common/BovinePrice";

class AdminPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      users: [],
    };
    this.refreshUsers = this.refreshUsers.bind(this);
  }

  refreshUsers() {
    getUsers((data) => {
      this.setState({ users: data.users });
    });
  }

  componentDidMount() {
    this.refreshUsers();
  }

  render() {
    //console.log("AdminPanel", this.props)
    return (
      <Container fluid className="main-content-container px-4">
        {/* Page Header */}
        <Row noGutters className="page-header py-4">
          <PageTitle
            sm="4"
            title="Panel de administración"
            className="text-sm-left"
          />
        </Row>
        <UsersTables
          users={this.state.users}
          refreshUsers={this.refreshUsers}
        />
        <BovinePrice />
      </Container>
    );
  }
}
export default AdminPanel;
